import { createApi } from "@reduxjs/toolkit/query/react";
import { RIDER_REQUEST, TagId, TagType } from "../../configs";
import {
  RiderRequest,
  PaginatedResponse,
  SearchByName,
  HttpMethod,
} from "../../types";
import { createBaseQuery } from "../helpers/baseQueryHelper";

const riderRequestApi = createApi({
  reducerPath: RIDER_REQUEST.reducerPath,
  baseQuery: createBaseQuery(RIDER_REQUEST.baseUrl),
  tagTypes: RIDER_REQUEST.tagTypes,
  endpoints(builder) {
    return {
      fetchRiderRequests: builder.query<
        PaginatedResponse<RiderRequest>,
        SearchByName
      >({
        query: (searchQuery) => {
          return {
            url: "/",
            method: HttpMethod.GET,
            params: searchQuery,
          };
        },
        providesTags: () => [{ type: TagType.RiderRequest, id: TagId.LIST }],
      }),

      deleteRiderRequest: builder.mutation<void, string>({
        query: (riderRequestId) => ({
          url: `/${riderRequestId}`,
          method: HttpMethod.DELETE,
        }),
        invalidatesTags: () => [{ type: TagType.RiderRequest, id: TagId.LIST }],
      }),
    };
  },
});

export const { useFetchRiderRequestsQuery, useDeleteRiderRequestMutation } =
  riderRequestApi;

export { riderRequestApi };
